export { SpaTreatmentFacilityDetailTemplate } from './SpaTreatmentFacilityDetailTemplate';
export type { SpaTreatmentFacilityTemplateProps } from './SpaTreatmentFacilityDetailTemplate.types';
